import { render } from "./ModelSearchForm.vue?vue&type=template&id=66fc39f4"
import script from "./ModelSearchForm.vue?vue&type=script&lang=js"
export * from "./ModelSearchForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__